import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: `calc(100vh - 60px)`,
				overflowY: "auto",
				position: "relative"
			},
			checkedRadio: {
				color: `${theme.palette.secondary.main} !important`
			},
			checkedDisabledRadio: {
				color: `${theme.palette.grey[700]} !important`
			},
			rootChecked: {
				fontSize: 13,
				textAlign: "justify",
				lineHeight: "22px !important",
				padding: "0px 16px"
			},
			rootRadio: {
				fontSize: 14,
				fontWeight: 400,
				padding: 0
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				width: 167,
				fontWeight: 400,
				textTransform: "initial",
				"&:active": {
					color: theme.white,
					opacity: 0.7,
					background: theme.palette.primary.main
				},
				"&:hover": {
					background: theme.palette.primary.main
				}
			},
			btnCancel: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				width: 167,
				fontWeight: 400,
				textTransform: "initial",
				"&:hover": {
					color: theme.palette.primary.contrastText
				}
			},
			documnet: {
				"& > div > canvas": {
					width: "100% !important",
					height: "150% !important",
					border: `1px solid ${theme.palette.grey[800]}`
				}
			},
			footerPdf: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				color: theme.palette.primary.contrastText,
				fontSize: 14
			},
			footerPdfConfirmed: {
				position: "fixed",
				bottom: 44,
				maxWidth: 450,
				width: "100%"
			}
		}),
	{
		name: "SignaturePage",
		index: 1
	}
);

export default useStyles;
